/**
 * CommonJS wrapper for locales
 * Supporting multiple tenants via TENANT_CONFIGS
 */

const TENANT = process.env.NEXT_PUBLIC_TENANT || 'default';

const TENANT_CONFIGS = {
  qmee: {
    accepted: ['en-au', 'en-ca', 'en-gb', 'en-us', 'de-de', 'fr-fr'],
    default: 'en-us',
  },
  default: {
    accepted: ['ar', 'bn', 'en', 'fr', 'hi'],
    default: 'en',
  },
};

// Select the active configuration
const activeConfig = TENANT_CONFIGS[TENANT] || TENANT_CONFIGS.default;

const ACCEPTED_LOCALES = activeConfig.accepted;
const DEFAULT_LOCALE = activeConfig.default;
const RTL_LOCALES = ['ar'];

// Organized Export Object
const locales = {
  ACCEPTED_LOCALES,
  DEFAULT_LOCALE,
  RTL_LOCALES,
};

// CommonJS Exports
module.exports = locales;
module.exports.ACCEPTED_LOCALES = ACCEPTED_LOCALES;
module.exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
module.exports.RTL_LOCALES = RTL_LOCALES;
